import React from 'react'

import loader from 'src/hoc/loader'
import NotFound from 'src/components/Errors/NotFound'

import { actionClearData, fetchSpacePlanById, fetchLatestSpacePlan } from './store'
import SpacePlansDetail from './SpacePlansDetail'

const getData = async ({ id }, dispatch) => {
  dispatch(actionClearData())
  await dispatch(id ? fetchSpacePlanById(id) : fetchLatestSpacePlan()).unwrap()
}

const options = {
  Custom404: (
    <NotFound
      title="Space Plan Not Found"
      message="The space plan you are looking for cannot be found."
    />
  ),
  extractProps: ({ params, authData, children }) => ({ ...params, ...authData, children }),
  shouldRefresh: ({ id: previousId }, { id }) => previousId !== id,
  onUnmount: dispatch => dispatch(actionClearData()),
}

export default loader(getData, options)(SpacePlansDetail)
